import { SERVICE_LINKS } from '@/lib/constants/common';
import { ContentFeature } from '@/lib/types/landing';

export const MAIN_SECTION_IMAGES = [
  {
    landscape: {
      small: '/images/main/img_main1-landscape_small.jpg',
      medium: '/images/main/img_main1-landscape_medium.jpg',
      large: '/images/main/img_main1-landscape_large.jpg'
    },
    portrait: {
      small: '/images/main/img_main1-portrait_small.jpg',
      medium: '/images/main/img_main1-portrait_medium.jpg'
    }
  },
  {
    landscape: {
      small: '/images/main/img_main2-landscape_small.jpg',
      medium: '/images/main/img_main2-landscape_medium.jpg',
      large: '/images/main/img_main2-landscape_large.jpg'
    },
    portrait: {
      small: '/images/main/img_main2-portrait_small.jpg',
      medium: '/images/main/img_main2-portrait_medium.jpg'
    }
  },
  {
    landscape: {
      small: '/images/main/img_main3-landscape_small.jpg',
      medium: '/images/main/img_main3-landscape_medium.jpg',
      large: '/images/main/img_main3-landscape_large.jpg'
    },
    portrait: {
      small: '/images/main/img_main3-portrait_small.jpg',
      medium: '/images/main/img_main3-portrait_medium.jpg'
    }
  },
  {
    landscape: {
      small: '/images/main/img_main4-landscape_small.jpg',
      medium: '/images/main/img_main4-landscape_medium.jpg',
      large: '/images/main/img_main4-landscape_large.jpg'
    },
    portrait: {
      small: '/images/main/img_main4-portrait_small.jpg',
      medium: '/images/main/img_main4-portrait_medium.jpg'
    }
  },
  {
    landscape: {
      small: '/images/main/img_main5-landscape_small.jpg',
      medium: '/images/main/img_main5-landscape_medium.jpg',
      large: '/images/main/img_main5-landscape_large.jpg'
    },
    portrait: {
      small: '/images/main/img_main5-portrait_small.jpg',
      medium: '/images/main/img_main5-portrait_medium.jpg'
    }
  }
];

export const CONTENT_FEATURES: ContentFeature[] = [
  {
    logoUrl: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/common/logo/bznav/logo_bznav-refund.svg`,
    backgroundClassName: 'bg-gradient-to-b from-white to-70%to-white',
    title: <>모든 사장님을 위한 세금 환급</>,
    description: (
      <>
        <span className={'text-neutral-foreground-main'}>고도화된 AI 기술로 받을 수 있는 공제·감면 항목을 빠짐없이 조회하고,</span> 전문가의 검증을 거쳐 누락
        없는 환급 경험을 제공해요.
      </>
    ),
    buttonText: '자세히 보기',
    buttonLink: SERVICE_LINKS['bznav-refund'],
    lottiePath: '/images/main/lottie/ani_refund_lottie.json'
  },
  {
    logoUrl: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/common/logo/bznav/logo_bznav-sena.svg`,
    logoHeight: '0.9375em',
    backgroundClassName: 'bg-gradient-to-b from-cyan-200 to-70% to-white',
    title: <>가장 똑똑한 세무 AI 어시스턴트</>,
    description: (
      <>
        <span className={'text-neutral-foreground-main'}>세무 고민이 생길 때마다 질문해보세요. </span>12만 건의 판례와 26만 건의 국세청 질의회신을 바탕으로 믿을
        수 있는 답변을 무료로 제공해요.
      </>
    ),
    buttonText: '자세히 보기',
    buttonLink: SERVICE_LINKS['bznav-sena'],
    lottiePath: '/images/main/lottie/ani_sena_lottie.json'
  },
  {
    logoUrl: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/common/logo/bznav/logo_bznav-care.svg`,
    backgroundClassName: 'bg-gradient-to-b from-pink-200 to-70% to-white',
    title: <>개인사업자를 위한 세무 기장</>,
    description: (
      <>
        <span className={'text-neutral-foreground-main'}>세무 기장, 이제 합리적인 가격으로 시작하세요.</span> 사업장 특성에 맞춘 절세 전략과 꼼꼼한 세무
        기장으로 안정적인 세무 관리를 도와드려요.
      </>
    ),
    buttonText: '자세히 보기',
    buttonLink: SERVICE_LINKS['bznav-care'],
    lottiePath: '/images/main/lottie/ani_care_lottie.json'
  }
];
